exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-01323e9e]{\n  width: 90%;\n}\n", ""]);

// exports
